import { Middleware } from '@nuxt/types'
import { CONSTANTS } from '@sohohouse/platform-resources'
import { APPLICATION_TYPES } from '~/constants'
import { Application } from '~/store/applications/applications/applications.types'

const applicationForm: Middleware = async ({ app, redirect, store, route }) => {
  let { path } = route

  // Remove trailing slash
  if (path.charAt(path.length - 1) === '/') {
    path = path.slice(0, path.length - 1)
  }

  if (!path.includes('/apply')) {
    return
  }

  const { currentUser } = store.getters

  if (!currentUser) {
    const redirectUrl = route.fullPath

    return redirect(app.localePath({ name: 'account-create', query: { redirectUrl } }))
  }

  const { type = APPLICATION_TYPES.HOUSE } = route.query

  if (!currentUser.membership.nonMemberAccount) {
    // Can't access at all if not friends, friends can only access house application
    if (currentUser.membership.subscriptionType !== CONSTANTS.SUBSCRIPTION_TYPES.FRIENDS || type !== APPLICATION_TYPES.HOUSE) {
      return redirect(app.localePath('index'))
    }
  }

  await store.dispatch('applications/applications/fetchApplications')


  const applications = store.getters['applications/applications/applications']

  const applicationWithType = applications.find(({ applicationType }: { applicationType: string }) => applicationType === type)
  const applyPage = app.localePath('apply')

  if (applicationWithType && path === applyPage) {
    const packagePage = app.localePath({ name: 'apply-id-package', params: { id: applicationWithType.id }})

    // TODO: Redirect based on completeness
    return redirect(packagePage)
  }

  if (!applications.length && path !== applyPage) {
    // They haven't started an application - take them to the start
    return redirect(applyPage)
  }

  return
}

export default applicationForm
